import { createOptionsFrom } from "@/lib/common/Option";

export const PublicTransactionSummariesSortOrderLabels = {
	Alphabetical: "Alphabetical",
	Quantity: "Quantity",
	MarketValue: "Market Value",
	UnitValue: "Unit Value"
} as const;

export type PublicTransactionSummariesSortOrder = keyof typeof PublicTransactionSummariesSortOrderLabels;

export const PublicTransactionSummariesSortOrderOptions = createOptionsFrom(PublicTransactionSummariesSortOrderLabels);
